import { useContext } from 'react'
import { Stack } from '@leroy-merlin-br/backyard-react-ui'

import { useProfile } from 'catalog/hooks/use-profile'

import { EntryKeyContext } from '../../context'
import { FilterTypes, FilterTitle } from './components'
import { Accordion, StockFilter, AppliedFilters, SwitchFilter } from '../'
import * as S from './styled'

const Filters = () => {
  const { filters, filterUsedOptions } = useContext(
    EntryKeyContext
  )
  const { isAssistedSale } = useProfile()

  return (
    <Stack spacing="bit">
      {filterUsedOptions?.length && (
        <S.Card>
          <AppliedFilters />
        </S.Card>
      )}

      <S.Card>
        <SwitchFilter
          optionClick={{
            name: 'produtos',
            value: 'ofertas',
            type: 'sorter',
            dataLayerOptions: {
              filter: 'Ofertas',
              filterType: { index: 0, value: 'Ofertas' },
              filterElement: { index: 0, value: 'Ofertas' }
            }
          }}
        >
          Somente ofertas
        </SwitchFilter>
      </S.Card>

      {isAssistedSale && (
        <S.Card>
          <StockFilter />
        </S.Card>
      )}

      {filters.map((filter, index) => (
        <Accordion
          key={filter.filterKey}
          title={<FilterTitle filter={filter} />}
        >
          <FilterTypes {...filter} filterTypeIndex={index} />
        </Accordion>
      ))}
    </Stack>
  )
}

export default Filters
